import { Component, EventEmitter, Input, Output } from '@angular/core';
import { JsonPipe } from '@angular/common';
import {WebViewerComponent} from './web-viewer/web-viewer.component';

@Component({
  selector: 'app-content-viewer',
  standalone: true,
  imports: [ WebViewerComponent],
  templateUrl: './content-viewer.component.html',
  styleUrl: './content-viewer.component.scss'
})
export class ContentViewerComponent {
  @Input() url: any;
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
    this.url = null;
  }
}
